import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '@material/material.module';

import { NumberPresenterComponent } from './number-presenter.component';

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: [NumberPresenterComponent],
  exports: [NumberPresenterComponent]
})
export class NumberPresenterModule {}
